/*
 * @Author: wufan 
 * @Date: 2020-08-21 16:40:36 
 * @Last Modified by: wufan
 * @Last Modified time: 2020-08-24 18:45:14
 * 灰色背景块
 */
<template>
  <div class="background-block">
    
  </div>
</template>

<script>
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
})
export default class GrayBackgroundBlock extends Vue {
  
}
</script>

<style lang="less">
  .background-block {
    background:#F8F9FC;
    width: 100%;
    height: 0.2rem;
    &:last-child {
      position: absolute;
      bottom: 1.96rem;
    }
  }
</style>






